export default __webpack_public_path__ + "static/media/small.a64d345f.jpg";